import Group from 'components/utils/Group'
import { INTL_DAY_LONG_MONTH } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import { rem } from 'polished'
import styled from 'styled-components'

const MessageContainer = styled(Group)`
  padding: ${rem(20)};
  width: ${rem(270)};
  border-radius: ${props => props.theme.borderRadius.L};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
`

const MessageContent = styled(BodyText)`
  overflow-wrap: anywhere;
`

interface Props {
  message: {
    authorName: string
    content: string
    date: string
  }
}

function WeddingMessage(props: Props) {
  const { message } = props

  return (
    <MessageContainer direction="vertical" gap={12} fullHeight verticalAlign="space-between">
      <MessageContent variant="medium" colour="light-foreground-alt">
        {message.content}
      </MessageContent>
      <Group direction="horizontal" gap={12} horizontalAlign="space-between" verticalAlign="center">
        <BodyText variant="medium" weight="bold">
          {message.authorName}
        </BodyText>
        <Caption variant="small" colour="light-foreground-alt" weight="bold" format="uppercase">{intlDateFormatter(message.date, INTL_DAY_LONG_MONTH)}</Caption>
      </Group>
    </MessageContainer>
  )
}

export default WeddingMessage
